import React, { Component, Fragment } from 'react'
import { ContentBlock } from 'components/common'
import PayerInfo from 'components/estimates/PayerInfo'
import PatientInfo from 'components/estimates/PatientInfo'
import AppointmentInfo from 'components/estimates/AppointmentInfo'
import { ThunkAction, MetadataObj } from 'store/types'
import FormButtons from './FormButtons'
import { ConfigurationState } from '../../../ducks/references/types'

interface UserInfo {
  dob?: string
  firstName?: string
  gender?: string
  lastName?: string
  middleInitial?: string
  relationships?: string
}

interface Props {
  form: IForm
  currentStep?: number
  patients?: object[]
  relationships?: object[]
  genders?: object[]
  appointments?: object[]
  physicians?: object[]
  cpt4Codes?: object[]
  cpt4List?: object[]
  fetchAppointments?: (value?: string | undefined) => ThunkAction
  onChangeInput?: (name: string, value: string | null) => void
  onRemoveElement?: (id : any) => void
  onSubmit?: any
  onCancel?: any
  onPrevPage?: any
  onNextPage?: any
  errors: MetadataObj
  onScrollToBottom: (appointmentType: string) => void
  onFetchChangeInput: (name: string, value: string | null) => void
  onShowPatientSubscriberChange?: (showPatientSubscriber: boolean) => void
  configuration?: ConfigurationState
  showPatientSubscriberFromParent?: boolean
}

interface NumbersArray {
  [index: string]: number
}

export interface IForm extends UserInfo {
  payer?: string | any
  memberId?: string
  dependent?: UserInfo
  relationship?: string
  appointmentType?: string
  appointmentIdSet?: NumbersArray
  appointmentList?: any[]
  cpt4Id?: BigInteger
  cpt4IdSet?: NumbersArray
  cpt4List?: any[]
  alsoSubscriber?: boolean
  physicianId?: string
  serviceAreaId?: string
  serviceCode?: string
  physician?: any
}

interface IFormState {
  alsoSubscriber: boolean
}

const pages = [PayerInfo, PatientInfo, AppointmentInfo]

class EstimateForm extends Component<Props, IFormState> {
  constructor(props: Props) {
    super(props)

    this.state = {
      alsoSubscriber: false
    }
  }

  onChangeInput = (name: string, value: string | null): void => {
    this.props.onChangeInput && this.props.onChangeInput(name, value)
  }

  onRemoveElement =  ( id: any ): void => {
    this.props.onRemoveElement && this.props.onRemoveElement(id)
  }

  render() {
    const {
      form,
      currentStep,
      patients,
      relationships,
      genders,
      appointments,
      physicians,
      cpt4Codes,
      fetchAppointments,
      onSubmit,
      onCancel,
      onNextPage,
      onPrevPage,
      errors,
      onScrollToBottom,
      configuration,
      onShowPatientSubscriberChange,
      showPatientSubscriberFromParent
    } = this.props

    const dynamicProps = [
      { patients },
      { relationships, genders },
      { fetchAppointments, appointments, physicians, cpt4Codes, configuration }
    ]

    if (currentStep || currentStep === 0) {
      const Form = pages[currentStep]
      return (
        <Fragment>
          <ContentBlock>
            <Form
              {...dynamicProps[currentStep]}
              errors={errors}
              form={form}
              onScrollToBottom={onScrollToBottom}
              onChangeInput={this.onChangeInput}
              onRemoveElement={this.onRemoveElement}
              onShowPatientSubscriberChange={onShowPatientSubscriberChange}
              showPatientSubscriberFromParent={showPatientSubscriberFromParent}
            />
          </ContentBlock>

          <FormButtons
            pages={pages}
            currentStep={currentStep}
            onSubmit={onSubmit}
            onCancel={onCancel}
            onPrevPage={onPrevPage}
            onNextPage={onNextPage}
          />
        </Fragment>
      )
    }

    return (
      <Fragment>
        {pages.map((page, i) => {
          const Form = page
          return (
            <ContentBlock>
              <Form
                key={i}
                {...dynamicProps[i]}
                errors={errors}
                form={form}
                onChangeInput={this.onChangeInput}
                onRemoveElement={this.onRemoveElement}
              />
            </ContentBlock>
          )
        })}
        <FormButtons
          pages={pages}
          currentStep={currentStep}
          onSubmit={onSubmit}
          onCancel={onCancel}
          onPrevPage={onPrevPage}
          onNextPage={onNextPage}
        />
      </Fragment>
    )
  }
}
export default EstimateForm
